import { Component, OnInit } from '@angular/core';
import { ConfirmacaoService, MensagemService, ProgressoService, Restricao, RestricaoOperador, Restricoes } from 'maestro-ng';
import { SelectItem } from 'primeng/api';
import { Classe } from '../classe.model';
import { ClasseService } from '../classe.service';
import { DataSourceRouted } from '../../util/data-source-routed';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-classe-lista',
  templateUrl: './classe-lista.component.html',
  styleUrls: ['./classe-lista.component.css'],
})
export class ClasseListaComponent implements OnInit {
  public ds: DataSourceRouted<Classe, number>;
  public tipoJusticaItens: SelectItem[];
  public naturezaItens: SelectItem[];

  constructor(
    private service: ClasseService,
    private progressoService: ProgressoService,
    private confirmacaoService: ConfirmacaoService,
    private mensagemService: MensagemService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.ds = new DataSourceRouted<Classe, number>(
      'administracao-classe',
      (c) => this.service.recuperarPaginado(c),
      this.mensagemService,
      this.progressoService,
      this.route,
      this.router,
      15,
      new Restricoes([
        new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
        new Restricao<string>({ atributo: 'descricao', operador: RestricaoOperador.CONTAINS }),
      ])
    );
  }

  ngOnInit(): void {}

  sincronizar(): void {
    this.progressoService.modal();
    this.service
      .sincronizar()
      .then(() => {
        this.progressoService.fechar();
        this.mensagemService.addSucesso('Sucesso', 'As classes foram sincronizadas com sucesso!');
      })
      .catch((response) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro', response.error);
      });
  }
}
